import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalSyncModal extends React.Component {
  render() {
    const {
      show,
      dmList,
      loadingDmList,
      syncStep,
      selectedDmIds,
      selectAllDm,
      establishmentFilter,
      dmRentalData,
      dmSearchTerm,
      onClose,
      onEstablishmentFilterChange,
      onDmSearchChange,
      onSelectAllDm,
      onDmSelect,
      onDmRentalDataChange,
      onGoToPreviousStep,
      onGoToNextStep,
      onConfirmDmSync,
      getFilteredDmList,
      getUniqueEstablishments,
      validateDmRentalData,
      globalStartDate,
      globalDailyPrice,
      onGlobalStartDateChange,
      onGlobalDailyPriceChange,
      onApplyGlobalValues,
    } = this.props;

    if (!show) return null;

    const filteredDmList = getFilteredDmList();
    const uniqueEstablishments = getUniqueEstablishments();

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={loadingDmList ? "static" : true}
        keyboard={!loadingDmList}
        centered
        size="xl"
        className="dm-sync-modal"
        dialogClassName="modal-90w"
      >
        <Modal.Header
          style={{
            background: "linear-gradient(135deg, #17a2b8 0%, #138496 100%)",
            border: "none",
            padding: "24px",
            borderRadius: "16px 16px 0 0",
            position: "relative",
          }}
        >
          <Modal.Title
            style={{
              color: "white",
              fontSize: "1.5rem",
              fontWeight: "700",
              textAlign: "center",
              width: "100%",
            }}
          >
            <i className="fas fa-sync-alt mr-2"></i>
            Synchronisation des DM du parc - Étape {syncStep}/2
          </Modal.Title>
          <button
            type="button"
            onClick={onClose}
            style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              background: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "50%",
              width: "36px",
              height: "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "18px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.2)";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.1)";
              e.target.style.transform = "scale(1)";
            }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>

        <Modal.Body
          style={{
            padding: "32px",
            backgroundColor: "#fafafa",
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {loadingDmList ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <div
                className="spinner-border text-info mb-3"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Chargement...</span>
              </div>
              <p style={{ color: "#6b7280", fontSize: "1.1rem" }}>
                Chargement de la liste des DM du PSDM...
              </p>
            </div>
          ) : dmList.length === 0 ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ height: "300px" }}
            >
              <i
                className="fas fa-info-circle text-warning mb-3"
                style={{ fontSize: "3rem" }}
              ></i>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "1.1rem",
                  textAlign: "center",
                }}
              >
                Aucun DM trouvé.
              </p>
            </div>
          ) : syncStep === 1 ? (
            <div>
              <h5
                style={{
                  color: "#1f2937",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Sélectionnez les DM à synchroniser ({filteredDmList.length} DM
                affichés)
              </h5>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="establishmentFilter"
                    style={{ fontWeight: "600", marginBottom: "8px" }}
                  >
                    Filtrer par établissement :
                  </label>
                  <select
                    id="establishmentFilter"
                    className="form-control"
                    value={establishmentFilter}
                    onChange={onEstablishmentFilterChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #d1d5db",
                      padding: "0px 12px",
                    }}
                  >
                    <option value="">Tous les établissements</option>
                    {uniqueEstablishments.map((establishment) => (
                      <option key={establishment} value={establishment}>
                        {establishment}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="dmSearchTerm"
                    style={{ fontWeight: "600", marginBottom: "8px" }}
                  >
                    Rechercher un DM :
                  </label>
                  <input
                    id="dmSearchTerm"
                    type="text"
                    className="form-control"
                    placeholder="Rechercher par référence, marque, désignation ou modèle..."
                    value={dmSearchTerm}
                    onChange={onDmSearchChange}
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #d1d5db",
                      padding: "10px 12px",
                    }}
                  />
                </div>
              </div>

              <div className="table-responsive">
                <table
                  className="table table-striped table-hover"
                  style={{ marginBottom: 0 }}
                >
                  <thead
                    style={{
                      backgroundColor: "#e2e8f0",
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    <tr>
                      <th style={{ padding: "12px 16px", width: "50px" }}>
                        <input
                          type="checkbox"
                          checked={selectAllDm}
                          onChange={onSelectAllDm}
                          style={{ transform: "scale(1.2)" }}
                        />
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          width: "20%",
                        }}
                      >
                        Référence interne
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          width: "25%",
                        }}
                      >
                        Type
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          width: "15%",
                        }}
                      >
                        Marque
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          width: "15%",
                        }}
                      >
                        Modèle
                      </th>
                      <th
                        style={{
                          padding: "12px 16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          width: "25%",
                        }}
                      >
                        Établissement client
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDmList.map((dm) => (
                      <tr
                        key={dm._id}
                        style={{ borderBottom: "1px solid #e2e8f0" }}
                      >
                        <td
                          style={{ padding: "12px 16px", textAlign: "center" }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedDmIds.includes(dm._id)}
                            onChange={() => onDmSelect(dm._id)}
                            style={{ transform: "scale(1.2)" }}
                          />
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            verticalAlign: "middle",
                            fontSize: "0.9rem",
                          }}
                        >
                          <strong style={{ color: "#1f2937" }}>
                            {dm.reference || "N/A"}
                          </strong>
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            verticalAlign: "middle",
                            fontSize: "0.9rem",
                            color: "#374151",
                          }}
                        >
                          {dm.designation || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            verticalAlign: "middle",
                            fontSize: "0.9rem",
                            color: "#374151",
                          }}
                        >
                          {dm.brand || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            verticalAlign: "middle",
                            fontSize: "0.9rem",
                            color: "#374151",
                          }}
                        >
                          {dm.model || "N/A"}
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            verticalAlign: "middle",
                          }}
                        >
                          <span
                            className="badge"
                            style={{
                              fontSize: "0.8rem",
                              padding: "6px 12px",
                              backgroundColor: "#17a2b8",
                              color: "white",
                              fontWeight: "500",
                              borderRadius: "6px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "180px",
                              display: "inline-block",
                            }}
                            title={dm.establishment || "N/A"}
                          >
                            {dm.establishment || "N/A"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div>
              <h5
                style={{
                  color: "#1f2937",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Configurez les locations pour les DM sélectionnés (
                {selectedDmIds.length} DM)
              </h5>

              {/* Section Appliquer à tous */}
              <div
                className="apply-to-all-section mb-4"
                style={{
                  backgroundColor: "#e0f2fe",
                  border: "1px solid #7dd3fc",
                  borderRadius: "10px",
                  padding: "20px",
                }}
              >
                <h6
                  style={{
                    color: "#0369a1",
                    fontWeight: "600",
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="fas fa-magic mr-2"></i>
                  Appliquer à tous les DM
                </h6>
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <label
                      className="form-label"
                      style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }}
                    >
                      Date de début pour tous
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={globalStartDate || ""}
                      onChange={(e) => onGlobalStartDateChange(e.target.value)}
                      style={{ fontSize: "0.9rem", borderRadius: "6px" }}
                    />
                  </div>
                  <div className="col-md-4">
                    <label
                      className="form-label"
                      style={{ fontWeight: "600", color: "#374151", marginBottom: "8px" }}
                    >
                      Prix journalier (€) pour tous
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="form-control"
                      value={globalDailyPrice || ""}
                      onChange={(e) => onGlobalDailyPriceChange(e.target.value)}
                      placeholder="0.00"
                      style={{ fontSize: "0.9rem", borderRadius: "6px" }}
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="button"
                      onClick={onApplyGlobalValues}
                      disabled={!globalStartDate && !globalDailyPrice}
                      style={{
                        width: "100%",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: (!globalStartDate && !globalDailyPrice) ? "#94a3b8" : "#0284c7",
                        color: "white",
                        fontSize: "0.95rem",
                        fontWeight: "600",
                        cursor: (!globalStartDate && !globalDailyPrice) ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <i className="fas fa-check-double mr-2"></i>
                      Appliquer à tous
                    </button>
                  </div>
                </div>
                <small style={{ color: "#64748b", marginTop: "12px", display: "block" }}>
                  Remplissez un ou les deux champs puis cliquez sur "Appliquer à tous" pour pré-remplir tous les équipements.
                </small>
              </div>

              <div className="row">
                {selectedDmIds.map((dmId) => {
                  const dm = dmList.find((d) => d._id === dmId);
                  const rentalData = dmRentalData[dmId] || {
                    startDate: "",
                    endDate: "",
                    dailyPrice: "",
                  };

                  return (
                    <div key={dmId} className="col-md-6 mb-4">
                      <div
                        className="card"
                        style={{
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                        }}
                      >
                        <div
                          className="card-header"
                          style={{
                            backgroundColor: "#f8fafc",
                            padding: "12px 16px",
                          }}
                        >
                          <h6
                            style={{
                              margin: 0,
                              color: "#1f2937",
                              fontWeight: "600",
                            }}
                          >
                            {dm.reference || "N/A"} - {dm.designation || "N/A"}
                          </h6>
                          <small style={{ color: "#6b7280" }}>
                            {dm.brand} {dm.model} - {dm.establishment}
                          </small>
                        </div>
                        <div className="card-body" style={{ padding: "16px" }}>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ fontWeight: "600", color: "#374151" }}
                            >
                              Date de début{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className={`form-control ${!rentalData.startDate ? "border-warning" : ""}`}
                              value={rentalData.startDate}
                              onChange={(e) =>
                                onDmRentalDataChange(
                                  dmId,
                                  "startDate",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: "0.9rem" }}
                            />
                            {!rentalData.startDate && (
                              <small
                                style={{
                                  color: "#f59e0b",
                                  fontSize: "0.8rem",
                                  marginTop: "4px",
                                }}
                              >
                                Ce champ est obligatoire
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ fontWeight: "600", color: "#374151" }}
                            >
                              Date de fin
                            </label>
                            <input
                              type="date"
                              className={`form-control ${rentalData.endDate && rentalData.startDate && rentalData.endDate < rentalData.startDate ? "border-danger" : ""}`}
                              value={rentalData.endDate}
                              min={rentalData.startDate || undefined}
                              onChange={(e) =>
                                onDmRentalDataChange(
                                  dmId,
                                  "endDate",
                                  e.target.value,
                                )
                              }
                              style={{ fontSize: "0.9rem" }}
                            />
                            {rentalData.endDate &&
                              rentalData.startDate &&
                              rentalData.endDate < rentalData.startDate && (
                                <small
                                  style={{
                                    color: "#ef4444",
                                    fontSize: "0.8rem",
                                    marginTop: "4px",
                                  }}
                                >
                                  La date de fin ne peut pas être antérieure à
                                  la date de début
                                </small>
                              )}
                          </div>
                          <div className="mb-3">
                            <label
                              className="form-label"
                              style={{ fontWeight: "600", color: "#374151" }}
                            >
                              Prix journalier (€){" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              className={`form-control ${!rentalData.dailyPrice ? "border-warning" : ""}`}
                              value={rentalData.dailyPrice}
                              onChange={(e) =>
                                onDmRentalDataChange(
                                  dmId,
                                  "dailyPrice",
                                  e.target.value,
                                )
                              }
                              placeholder="0.00"
                              style={{ fontSize: "0.9rem" }}
                            />
                            {!rentalData.dailyPrice && (
                              <small
                                style={{
                                  color: "#f59e0b",
                                  fontSize: "0.8rem",
                                  marginTop: "4px",
                                }}
                              >
                                Ce champ est obligatoire
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            padding: "24px 32px",
            backgroundColor: "#fafafa",
            border: "none",
            borderRadius: "0 0 16px 16px",
            display: "flex",
            justifyContent: syncStep === 2 ? "space-between" : "flex-end",
          }}
        >
          {syncStep === 2 && (
            <button
              onClick={onGoToPreviousStep}
              style={{
                padding: "12px 24px",
                border: "2px solid #6b7280",
                borderRadius: "12px",
                backgroundColor: "white",
                color: "#6b7280",
                fontSize: "0.95rem",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              <i className="fas fa-arrow-left mr-2"></i>
              Précédent
            </button>
          )}

          {syncStep === 1 ? (
            <button
              onClick={onGoToNextStep}
              disabled={selectedDmIds.length === 0}
              style={{
                padding: "12px 24px",
                border:
                  selectedDmIds.length === 0
                    ? "2px solid #d1d5db"
                    : "2px solid #17a2b8",
                borderRadius: "12px",
                backgroundColor:
                  selectedDmIds.length === 0 ? "#f9fafb" : "#17a2b8",
                color: selectedDmIds.length === 0 ? "#9ca3af" : "white",
                fontSize: "0.95rem",
                fontWeight: "600",
                cursor: selectedDmIds.length === 0 ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                minWidth: "120px",
              }}
            >
              Suivant
              <i className="fas fa-arrow-right ml-2"></i>
            </button>
          ) : (
            <button
              onClick={onConfirmDmSync}
              disabled={!validateDmRentalData()}
              style={{
                padding: "12px 24px",
                border: validateDmRentalData()
                  ? "2px solid #10b981"
                  : "2px solid #d1d5db",
                borderRadius: "12px",
                backgroundColor: validateDmRentalData() ? "#10b981" : "#f9fafb",
                color: validateDmRentalData() ? "white" : "#9ca3af",
                fontSize: "0.95rem",
                fontWeight: "600",
                cursor: validateDmRentalData() ? "pointer" : "not-allowed",
                transition: "all 0.2s ease",
                minWidth: "140px",
                opacity: validateDmRentalData() ? 1 : 0.6,
              }}
            >
              <i className="fas fa-check mr-2"></i>
              Créer les locations
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalSyncModal;
